export { default } from './TableHead';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/TableHead/index.js
// module id = 600
// module chunks = 121